import i18n from "@/lang";

class ErrorService {
    public normalize(err: string, defaultErr?: string): {err: string, showNotiSystem: boolean} {
        if (!err) {
            return {err, showNotiSystem: false}
        }
        err = "" + err
        const t: any = i18n.messages[i18n.locale]
        if (err.toLowerCase().indexOf("no such host") > -1) {
            return {err: t.ERROR_SERVICE.ERROR_SERVICE_HOST_NAME, showNotiSystem: true}
        } else if (err.toLowerCase().indexOf("client.timeout") > -1) {
            return {err:  t.ERROR_SERVICE.ERROR_SERVICE_CONNECT_TIMEOUT, showNotiSystem: true}
        } else if (err.toLowerCase().indexOf("temporary failure") > -1) {
            return {err:  t.ERROR_SERVICE.ERROR_SERVICE_HOST_NAME, showNotiSystem: true}
        } else if (err.toLowerCase().indexOf("connection refused") > -1) {
            return {err:  t.ERROR_SERVICE.ERROR_SERVICE_HOST_NAME, showNotiSystem: true}
        } else if (err.toLowerCase().indexOf("network is unreachable") > -1) {
            return {err:  t.ERROR_SERVICE.ERROR_SERVICE_HOST_NAME, showNotiSystem: true}
        } else if (err.toLowerCase().indexOf("dial tcp: lookup") > -1) {
            return {err:  t.ERROR_SERVICE.ERROR_SERVICE_HOST_NAME, showNotiSystem: true}
        } else if (err.indexOf("Too many request") > -1) {
            const extractedError = err.substring(err.indexOf("Too many request"));
            return {err: defaultErr || extractedError, showNotiSystem: false}
        } else if (err.indexOf("Error: ") > -1) {
            return {err:  t.ERROR_SERVICE.ERROR_SERVICE_GENERAL, showNotiSystem: true}
        }

        return {err: defaultErr || err, showNotiSystem: false}
    }
}

export default new ErrorService()
